import React from 'react';

const SpinnerIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    fill='none'
    className={className}
    aria-label='Loading'
    role='status'
  >
    <circle
      cx='12'
      cy='12'
      r='10'
      stroke='currentColor'
      strokeWidth='3'
      className='opacity-25'
    />
    <path
      fill='currentColor'
      d='M22 12A10 10 0 0 0 12 2v3a7 7 0 0 1 7 7h3Z'
      className='opacity-100'
    />
  </svg>
);

export default SpinnerIcon;
